import styled from 'styled-components'
import Card from 'components/Card'

export const CardBody = styled(Card.Body)`
  padding: 0 0.8rem;
`
